exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".btn-filter[data-v-4f357eee]{margin-top:20px}", "", {"version":3,"sources":["/app/src/components/requests/Requests.vue"],"names":[],"mappings":"AACA,6BACE,eAAiB,CAClB","file":"Requests.vue","sourcesContent":["\n.btn-filter[data-v-4f357eee] {\n  margin-top: 20px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4f357eee","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/requests/Requests.vue
// module id = 507
// module chunks = 7